<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          تخفیفات
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="result">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header >
              جستجوی پیشرفته
            </v-expansion-panel-header>
            <v-expansion-panel-content class="mt-3">
              <v-row>
                <v-col
                    cols="12"
                    sm="4"
                    md="4">
                  <v-autocomplete
                      :items="data.mainGroupItems"
                      v-model="model.mainGroupId"
                      dense
                      outlined
                      @change="getSubGroupList"
                      auto-select-first  append-icon="fas fa-angle-down"
                      label="انتخاب گروه اصلی"

                  />

                </v-col>
                <v-col
                    cols="12"
                    sm="4"
                    md="4">
                  <v-autocomplete
                      :items="subGroupItems"
                      v-model="model.subGroupId"
                      dense
                      outlined
                      auto-select-first  append-icon="fas fa-angle-down"
                      label="انتخاب گروه فرعی"

                  />

                </v-col>
                <v-col
                    cols="12"
                    sm="4"
                    md="4">

                  <v-text-field
                      label="نام "
                      outlined
                      dense
                      v-model="model.name"
                  />

                </v-col>
                <v-col
                    cols="12"
                    sm="4"
                    md="4">

                  <v-text-field
                      label="درصد تخفیف "
                      outlined
                      dense
                      type="number"
                      v-model="model.discountPercent"
                  />

                </v-col>
                <v-col
                    cols="12"
                    sm="4"
                    md="4">

                  <v-text-field
                      label="تلفن"
                      outlined
                      dense
                      v-model="model.phone"
                  />

                </v-col>
                <v-col
                    cols="12"
                    sm="4"
                    md="4">

                  <v-btn  block   color="primary" @click="advancedSearch" class="mr-1">
                    جستجو
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
        <v-card-text v-if="result">
        <v-row>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                clearable
                @click:clear="fillDataItems"
                dense
                placeholder="جستجو..."
                v-model="searchvalue"

            />
            <v-btn  fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
        </v-row>
        <v-card-title>گروه های اصلی</v-card-title>
        <v-sheet
            class="mx-auto"
            elevation="8"
           >
          <v-slide-group
              class="pa-2"
              active-class="warning"
              show-arrows>
  <v-slide-item
      v-for="item in dataItems" :key="item.codeGroup"

      v-slot="{ active,toggle}"
  >
    <v-card
        :color="active ? undefined : '#ffa650'"
        class="ma-4"
        height="100"
        width="120"
        @click="toggle"
    >
      <v-card height="100"
              width="120"
              style="background: transparent!important;"
              @click="toggle1(item)">
        <v-card-text style="color: black">{{item.nameGroup}}</v-card-text>
      </v-card>

    </v-card>
  </v-slide-item>
</v-slide-group></v-sheet>

      </v-card-text>
      <v-card-text v-if="subGroupList.length>0" >
        <v-card-title> گروه های فرعی</v-card-title>
        <v-sheet
            class="mx-auto"
            elevation="8"
        >
          <v-slide-group
              class="pa-2"
              active-class="primary"
              show-arrows>
            <v-slide-item
                v-for="(item, i) in subGroupList"
                :key="i"
                v-slot="{ active,toggle}"
            >
<!--    <v-col cols="12" sm="4">-->
              <v-card
                  :color="active ? undefined : '#50a9ff'"
                  class="ma-4"
                  height="90"
                  width="100"
                  @click="toggle"
              >
                <v-card height="90"
                        width="100"
                        style="background: transparent!important;"
                    @click="getMainJobList(item.id)">
                  <v-card-text style="color: black">{{item.nameSub}}</v-card-text>

                </v-card>
              </v-card>

            </v-slide-item>
          </v-slide-group>
        </v-sheet>
</v-card-text>

        <section class="style-1 m-2" style="overflow-x: hidden!important;overflow-y: auto!important;height: 800px ">

          <v-list
              v-if="mainJobeList.length>0"
              subheader
              three-line
          >
            <v-subheader>کارهای اصلی</v-subheader>
<!--            <v-row>-->
              <v-col sm="6"  v-for="mj in mainJobeList" :key="mj.id">
                <v-list-item >
<!--                  <v-card>-->
                    <v-list-item-content>
                      <v-card-title>{{mj.name}}  <span style="color: red; font-size: 18px">{{mj.discountPercent}}%</span></v-card-title>
                      <br/>
                      <v-card-subtitle>شماره تلفن: {{mj.phone}}</v-card-subtitle>
                      <v-card-text>آدرس: {{mj.address}}</v-card-text>
                    </v-list-item-content>
<!--                  </v-card>-->

                </v-list-item>
                <v-divider/>
              </v-col>

          </v-list>

          <v-row>

          </v-row>
        </section>



    </v-card>
  </div>
</template>

<script>
import Discount_se from "./Discount_se";
import MainJob_se from "@/views/define/mainJob/MainJob_se";
import {mapMutations} from "vuex";


export default {
  name: 'MainJob',

  data() {
    return {
      searchvalue: '',
      modelId: '',
      model: {},
      data: {},
      dataItems: [],
      subGroupList: [],
      subGroupItems: [],
      result: false,
      isDiscount: false,
      mainJobeList: [],

    };

  },

  mounted() {
    this.$root.$on('MainJob', () => {
      this.fillDataItems()
    })

  },

  methods: {

    close(){
      this.searchvalue=""
      this.$root.$emit('MainJob')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    fillDataItems() {
      this.searchvalue=''
      this.dataItems=[]
      this.subGroupList=[]
      this.mainJobeList=[]
      Discount_se.getPage( ).then(response => {
        this.data = response.data
        this.dataItems = response.data.mainGroupList
        this.model = response.data.model
      });
    },

    getMainJobList(id){
      Discount_se.getMainJobList(id).then(response=>{
        this.mainJobeList=response.data
      })
    },
    getSubGroupList(val){
      MainJob_se.getSubGroupList(val).then(response=>{
        return  this.subGroupItems=response.data.subGroupItems
      })
    },

    toggle1(item){
       this.subGroupList=item.subGroupList
       this.mainJobeList=[]
    },
    checkRemainder(){
      Discount_se.checkRemainder().then(response=>{

        if (response && response.status === 200) {
          this.result=response.data.result
          this.isDiscount=response.data.isDiscount
          if(!this.isDiscount){
            this.$snack({message:response.response.data,type: 'error'})
            this.$router.push("/home")
          }
          if(this.result){
            this.fillDataItems();
          }else {
            this.$snack({message:response.response.data,type: 'error'})
            this.$router.push("/account")
          }
        }else if (response && response.response.status === 400) {
          this.$snack({message:response.response.data,type: 'error'})
          this.$router.push("/home")
        }



      })
    },

    search(){
      if(this.searchvalue.length>2){
        Discount_se.search(this.searchvalue).then(result=>{
          this.dataItems=result.data.mainGroups
          this.subGroupList=result.data.subGroups
          this.mainJobeList=result.data.mainJobs
        })
      }else if(this.searchvalue.length===0){
        this.fillDataItems()

      }
    },
    advancedSearch(){
      Discount_se.advancedSearch(this.model).then(result=>{
        this.dataItems=result.data.mainGroups
        this.subGroupList=result.data.subGroups
        this.mainJobeList=result.data.mainJobs
      })
    }


  },

  created() {
    this.setDrawer(false)
    this.checkRemainder()
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}



.style-1::-webkit-scrollbar {
  width: 2px;
  background-color: #F5F5F5;
}

.style-1::-webkit-scrollbar-thumb {
  background-color: #F90;
  background-image: -webkit-linear-gradient(90deg, rgba(255, 255, 255, .2) 25%,orange,
  orange)
}

.style-1::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}

</style>
